import { Controller } from '@hotwired/stimulus'

const POLL_INTERVAL = 5000

export default class extends Controller {
  static values = { url: String };

  connect () {
    this.timer = setInterval(() => this.reload(), POLL_INTERVAL)
  }

  disconnect () {
    clearInterval(this.timer)
  }

  reload () {
    const frame = this.element.closest('turbo-frame')
    if (frame && this.urlValue) {
      frame.src = this.urlValue
    }
  }
}
